"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refundSchema = void 0;
var received_adjustment_1 = require("./received-adjustment");
var request_letter_1 = require("./request-letter");
exports.refundSchema = {
    type: 'object',
    required: ['receivedAdjustments', 'requestLetters'],
    properties: {
        receivedAdjustments: {
            type: 'array',
            items: received_adjustment_1.receivedAdjustmentSchema,
        },
        requestLetters: {
            type: 'array',
            items: request_letter_1.requestLetterSchema,
        },
    },
};
